export default "__VITE_ASSET__BhximIlf__"